import React, { useId } from 'react';

interface BrandLogoProps {
  size?: number;
  className?: string;
  title?: string;
}

export const BrandLogo: React.FC<BrandLogoProps> = ({
  size = 28,
  className = '',
  title = 'Finance Compass logo'
}) => {
  const uid = useId();
  const ringId = `${uid}-ring`;
  const needleId = `${uid}-needle`;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      className={className}
      role="img"
      aria-label={title}
    >
      <defs>
        <linearGradient id={ringId} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="rgb(var(--glow-1))" />
          <stop offset="100%" stopColor="rgb(var(--compass-accent))" />
        </linearGradient>
        <linearGradient id={needleId} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="rgb(var(--compass-accent))" />
          <stop offset="100%" stopColor="rgb(var(--glow-1))" />
        </linearGradient>
      </defs>
      <circle cx="32" cy="32" r="26" fill="none" stroke={`url(#${ringId})`} strokeWidth="3.2" />
      <circle cx="32" cy="32" r="12" fill="none" stroke="currentColor" strokeWidth="1.5" opacity="0.5" />
      <circle cx="32" cy="32" r="19" fill="none" stroke="currentColor" strokeWidth="0.8" opacity="0.25" />
      <line x1="32" y1="5" x2="32" y2="13" stroke="currentColor" strokeWidth="1.7" />
      <line x1="32" y1="51" x2="32" y2="59" stroke="currentColor" strokeWidth="1.7" />
      <line x1="5" y1="32" x2="13" y2="32" stroke="currentColor" strokeWidth="1.7" />
      <line x1="51" y1="32" x2="59" y2="32" stroke="currentColor" strokeWidth="1.7" />
      <path
        d="M32 8 L40.5 30.5 L32 26.5 L23.5 30.5 Z"
        fill={`url(#${needleId})`}
        stroke="currentColor"
        strokeWidth="1.1"
        strokeLinejoin="round"
      />
      <path
        d="M32 56 L23.5 33.5 L32 37.5 L40.5 33.5 Z"
        fill="currentColor"
        opacity="0.25"
        stroke="currentColor"
        strokeWidth="0.9"
        strokeLinejoin="round"
      />
      <circle cx="32" cy="32" r="3.2" fill="rgb(var(--compass-accent))" />
    </svg>
  );
};
